import { format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import img from '../orcamento/text.txt'

function clientesPDF(dados_pedido, tipoImpressao) {
  try {
    const clientes = dados_pedido.itens
    const obs = dados_pedido.detalhes_pedido
    const NomeCliente = dados_pedido.cliente
    const Parceiro = dados_pedido.Parceiro
    const numeroorc = dados_pedido.numeroorc
    const { data, cpf } = dados_pedido
    const dataFormatada = format(parseISO(data), 'dd/MM/yyyy')
    const empresa = dados_pedido.empresa[0]
    const DadosCliente = dados_pedido.dadosDoCliente
    console.log('itens',clientes)

    const formatDateTime = () => {
      const now = new Date()
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      }
      return now.toLocaleDateString('pt-BR', options)

     
    }


   

    function formatarCPFouCNPJ(cpfOuCnpj) {
      // Verifica se o valor é nulo
      if (cpfOuCnpj === null) {
        return 'N/I'
      }

      // Remove todos os caracteres não numéricos
      const cpfOuCnpjLimpo = cpfOuCnpj.replace(/\D/g, '')

      // Verifica se é CPF (11 dígitos) ou CNPJ (14 dígitos)
      if (cpfOuCnpjLimpo.length === 11) {
        return cpfOuCnpjLimpo.replace(
          /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
          '$1.$2.$3-$4',
        ) // Formata CPF: XXX.XXX.XXX-XX
      } else if (cpfOuCnpjLimpo.length === 14) {
        return cpfOuCnpjLimpo.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
          '$1.$2.$3/$4-$5',
        ) // Formata CNPJ: XX.XXX.XXX/YYYY-ZZ
      } else {
        // Se o CPF ou CNPJ não tiver o tamanho correto, retorna como está
        return cpfOuCnpj
      }
    }

    const cpfOuCnpjFormatado = formatarCPFouCNPJ(cpf)

    const clienteNomeComCPF = cpfOuCnpjFormatado
      ? `${NomeCliente}\nCPF/CNPJ: ${cpfOuCnpjFormatado}`
      : NomeCliente

    function formatCurrency(value) {
      if (value === null || isNaN(value)) {
        return '0,00'
      }
      return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })
    }

    function formatNumber(value) {
      if (value === null || isNaN(value)) {
        return '0,00'
      }
      return Number(value).toFixed(2).toLocaleString('pt-BR').replace('.', ',')
    }

    pdfMake.addVirtualFileSystem(pdfFonts)

    const primaryColor = '#007BFF'
    const secondaryColor = '#333333'

    const styles = {
      tableExample: {
        margin: [0, 5, 0, 15],
      },
      tableHeader: {
        bold: true,
        fontSize: 12,
        color: primaryColor,
        alignment: 'center',
      },
      tableHeaderBackground: {
        fillColor: primaryColor,
        color: '#fff',
        bold: true,
        alignment: 'center',
        fontSize: 6,
      },
    }

    const reportTitle = [
      {
        text: 'Proposta Comercial',
        fontSize: 24,
        bold: true,
        margin: [0, 0, 0, 20],
        color: primaryColor,
      },
    ]
    const orcamento = [
      {
        text: 'Detalhes do Cliente:',
        fontSize: 12,
        bold: true,
        color: primaryColor,
        margin: [0, 0, 0, 10],
      },
      {
        text: [
          {
            text: `Cliente: ${clienteNomeComCPF}\n`,
            fontSize: 9,
            margin: [0, 0, 0, 5],
          },
          {
            text:
              `Proposta: ${numeroorc}\n` +
              (Parceiro && Parceiro !== 'Selecione um parceiro'
                ? `Indicador da Venda: ${Parceiro}\n`
                : ''),
            fontSize: 9,
            margin: [0, 0, 0, 5],
          },
          {
            text: `Data: ${dataFormatada}\n`,
            fontSize: 9,
            margin: [0, 0, 0, 20],
          },
          {
            text: 'Endereço do Cliente:\n',
            fontSize: 11,
            bold: true,
            margin: [0, 0, 0, 8],
          },
          DadosCliente?.pes_logradouro || DadosCliente?.pes_numero
            ? {
                text: `${DadosCliente.pes_logradouro || ''}${DadosCliente.pes_numero ? ', ' + DadosCliente.pes_numero : ''}\n`,
                fontSize: 9,
              }
            : '',
          DadosCliente?.pes_complemento
            ? {
                text: `${DadosCliente.pes_complemento || ''}\n`,
                fontSize: 9,
              }
            : '',
          DadosCliente?.pes_bairro
            ? { text: `${DadosCliente.pes_bairro}\n`, fontSize: 9 }
            : '',
          DadosCliente?.pes_cidade || DadosCliente?.pes_uf
            ? {
                text: `${DadosCliente.pes_cidade || ''}${DadosCliente.pes_uf ? ' - ' + DadosCliente.pes_uf : ''}\n`,
                fontSize: 9,
              }
            : '',
          DadosCliente?.pes_cep
            ? { text: `CEP: ${DadosCliente.pes_cep}\n`, fontSize: 9 }
            : '',
          DadosCliente?.pes_celular
            ? { text: `Contato: ${DadosCliente.pes_celular}\n`, fontSize: 9 }
            : '',
        ].filter(Boolean), // Remove elementos vazios
        margin: [0, 0, 10, 0],
      },
    ]

    const larguraColunas = [
      'auto',
      'auto',
      'auto',
      'auto',
      'auto',
      'auto',
      'auto',
      '*',
      'auto',
      'auto',
      'auto',
      'auto',
    ]

    let grupoAtual = null
    let totalGrupo = 0
    let dados = []

    clientes.forEach((cliente) => {
      if (grupoAtual !== cliente.grupo_item) {
        if (grupoAtual !== null) {
          dados.push([
            {
              text: `Total ${grupoAtual}: ${formatCurrency(totalGrupo)}`,
              colSpan: 9, // Altere colSpan para 9
              bold: true,
              fontSize: 6,
            },
            {},
            {},
            {},
            {},
            {},
            {},
            {},
            {},
            {},
            {},
            {},
          ])
          totalGrupo = 0
          dados.push([
            { text: '', colSpan: 9 },
            {},
            {},
            {},
            {},
            {},
            {},
            {},
            {},
            {},
            {},
            {},
          ]) // Espaço em branco
        }
        grupoAtual = cliente.grupo_item
        if (grupoAtual !== null && grupoAtual !== undefined) {
          dados.push([
            {
              text: `Ambiente: ${grupoAtual}`,
              colSpan: 9, // Altere colSpan para 9
              bold: true,
              fontSize: 6,
            },
            {},
            {},
            {},
            {},
            {},
            {},
            {},
            {},
            {},
            {},
            {},
          ])
        }
      }

      let valorTotalItem = cliente.valor_total_item
      totalGrupo += valorTotalItem

      const item = [
        {
          image: cliente.base64,
          width: 30,
          height: 30,
        },
        {
          text: cliente.deposito
            ? String(cliente.deposito).toUpperCase()
            : 'N/I',
          fontSize: 6,
          margin: [0, 2, 0, 2],
        },
        {
          text: cliente.rua ? String(cliente.rua).toUpperCase() : 'N/I',
          fontSize: 6,
          margin: [0, 2, 0, 2],
        },
        {
          text: cliente.predio ? String(cliente.predio).toUpperCase() : 'N/I',
          fontSize: 6,
          margin: [0, 2, 0, 2],
        },
        {
          text:
            typeof cliente.nivel === 'number'
              ? String(cliente.nivel).toUpperCase()
              : 'N/I',
          fontSize: 6,
          margin: [0, 2, 0, 2],
        },
        {
          text: cliente.apto ? String(cliente.apto).toUpperCase() : 'N/I',
          fontSize: 6,
          margin: [0, 2, 0, 2],
        },
        {
          text: cliente.codigo ? cliente.codigo.toUpperCase() : 'N/I',
          fontSize: 6,
          margin: [0, 2, 0, 2],
        },
        {
          text:
            tipoImpressao === 'Resumo'
              ? cliente.descricao
                ? cliente.descricao.split(' ')[0].toUpperCase()
                : 'N/I'
              : cliente.descricao
                ? cliente.descricao.toUpperCase()
                : 'N/I',
          fontSize: 6,
          margin: [0, 2, 0, 2],
          width: 150,
        },
        {
          text: formatNumber(cliente.quantidade),
          fontSize: 6,
          margin: [0, 2, 0, 2],
          alignment: 'right',
        },
        {
          text: formatCurrency(cliente.valorunitario),
          fontSize: 6,
          margin: [0, 2, 0, 2],
        },
        {
          text: formatCurrency(valorTotalItem),
          fontSize: 6,
          margin: [0, 2, 0, 2],
        },
        {
          text: cliente.obs || 'S/Obs',
          fontSize: 6,
          margin: [0, 2, 0, 2],
        },
      ]

      dados.push(item)
    })

    // Adiciona o total do último grupo
    if (grupoAtual !== null && grupoAtual !== undefined) {
      dados.push([
        {
          text: `Total ${grupoAtual}: ${formatCurrency(totalGrupo)}`,
          colSpan: 9, // Altere colSpan para 9
          bold: true,
          fontSize: 6,
        },
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
      ])
    }

    // Aqui você pode usar 'dados' como quiser, por exemplo, para gerar um PDF com o pacote 'pdfmake'

    const details = [
      {
        table: {
          headerRows: 1,
          widths: larguraColunas,
          body: [
            [
              {
                text: 'Imagem',
                style: 'tableHeaderBackground',
                color: '#fff',
                fontSize: 6,
              },
              {
                text: 'Sku',
                style: 'tableHeaderBackground',
                color: '#fff',
                fontSize: 6,
              },
              {
                text: 'Descrição',
                style: 'tableHeaderBackground',
                color: '#fff',
                fontSize: 6,
              },
              {
                text: 'Quantidade',
                style: 'tableHeaderBackground',
                color: '#fff',
                fontSize: 6,
              },
              {
                text: 'Valor Uni. ',
                style: 'tableHeaderBackground',
                color: '#fff',
                fontSize: 6,
              },
              {
                text: 'Valor Total Item',
                style: 'tableHeaderBackground',
                color: '#fff',
                fontSize: 6,
              },
              {
                text: 'Valor Total',
                style: 'tableHeaderBackground',
                color: '#fff',
                fontSize: 6,
              },
              {
                text: 'Obs',
                style: 'tableHeaderBackground',
                color: '#fff',
                fontSize: 6,
              },
            ],
            ...dados,
          ],
          style: 'tableStyle', // Adicione este estilo à tabela
        },
      },
    ]

    //let details = []

    // Agora você pode usar pdfMake para gerar o PDF com a tabela sem bordas laterais e verticais

    const totalItens = clientes.reduce(
      (acc, cliente) => acc + cliente.valorunitario * cliente.quantidade,
      0,
    )
    const totalDescontos = clientes.reduce(
      (acc, cliente) => acc + (cliente.desconto || 0),
      0,
    ) // Certifique-se de que desconto seja um número válido ou 0
    const valorTotalComDesconto = totalItens - totalDescontos
    const Totais = [
      {
        table: {
          widths: ['*', 'auto'],
          body: [
            [
              {
                text: 'Valor Total dos Itens',
                style: 'tableFooter',
                color: primaryColor,
              },
              {
                text: formatCurrency(totalItens),
                style: 'tableFooter',
                color: primaryColor,
                alignment: 'right',
              },
            ],
            [
              {
                text: 'Valor Total do Desconto',
                style: 'tableFooter',
                color: primaryColor,
              },
              {
                text: formatCurrency(totalDescontos),
                style: 'tableFooter',
                color: primaryColor,
                alignment: 'right',
              },
            ],
            [
              {
                text: 'Total a Pagar',
                style: 'tableFooter',
                color: primaryColor,
              },
              {
                text: formatCurrency(valorTotalComDesconto),
                style: 'tableFooter',
                color: primaryColor,
                alignment: 'right',
              },
            ],
          ],
        },
        layout: 'noBorders',
      },
    ]

    function Rodape(currentPage, pageCount) {
      return [
        {
          text:
            'Impresso em ' +
            format(new Date(), 'dd/MM/yyyy HH:mm', { locale: ptBR }) +
            ' ZipHub Gestão',
          alignment: 'center',
          fontSize: 8,
          color: secondaryColor,
          margin: [0, 10, 0, 0],
        },
        {
          text: currentPage + ' / ' + pageCount,
          alignment: 'right',
          fontSize: 9,
          margin: [0, 10, 20, 0],
        },
      ]
    }

    const cnpj = empresa?.EMP_CNPJ || 'N/I'

    const companyDetails = [
      {
        stack: [
          {
            text: empresa?.EMP_RAZAO_SOCIAL,
            fontSize: 12,
            bold: true,
            color: secondaryColor,
          },
          {
            text: `${empresa?.EMP_ENDERECO}, ${empresa?.EMP_NUMERO} - ${empresa?.EMP_CIDADE}-${empresa.EMP_ESTADO} Cep: ${empresa.EMP_CEP}`,
            fontSize: 10,
            color: secondaryColor,
          },
          {
            text: `Telefone: ${empresa.EMP_TELEFONE}`,
            fontSize: 10,
            color: secondaryColor,
          },
          {
            text: `CNPJ: ${empresa.EMP_CNPJ}`,
            fontSize: 10,
            color: secondaryColor,
          },
        ],
        alignment: 'right',
        margin: [0, 10, 20, 0],
      },
    ]

    // const companyDetails = [
    //     {
    //         text: empresa?.EMP_RAZAO_SOCIAL,
    //         alignment: "right",
    //         fontSize: 12,
    //         bold: true,
    //         margin: [0, 10, 20, 0],
    //         color: "#6C757D"
    //     },
    //     {
    //         text: empresa?.EMP_ENDERECO + ', ' + empresa?.EMP_NUMERO + ' - ' + empresa?.EMP_CIDADE + '-' + empresa?.EMP_ESTADO +
    //             ' Cep: ' + empresa?.EMP_CEP,
    //         alignment: 'right',
    //         fontSize: 10,
    //         margin: [0, 0, 20, 0],
    //         color: secondaryColor,
    //     },
    //     {
    //         text: 'Telefone: ' + empresa?.EMP_TELEFONE,
    //         alignment: 'right',
    //         fontSize: 10,
    //         margin: [0, 0, 20, 0],
    //         color: secondaryColor,
    //     },
    //     {
    //         text: 'CNPJ: ' + cnpj,
    //         alignment: 'right',
    //         fontSize: 10,
    //         margin: [0, 0, 20, 0],
    //         color: secondaryColor,
    //     },
    // ];

    console.log(companyDetails)

    const additionalInfo = {
      text: 'Produtos sob encomenda ou perfis com medidas específicas para o projeto, não aceitamos trocas.\nValidade do orçamento: 15 dias.',
      fontSize: 8,
      bold: true,
      //    color: '#000000', // Texto preto
      background: '#D3D3D3', // Fundo cinza
      margin: [0, 10, 0, 10], // Margem
      alignment: 'center', // Centralizado (opcional)
    }

    const docDefinition = {
      pageSize: 'A4',
      pageMargins: [15, 50, 15, 40],

      header: [...companyDetails],

      content: [
        ...reportTitle,
        ...orcamento,
        { text: ' ', margin: [0, 10] },
        {
          table: {
            headerRows: 1,
            widths: larguraColunas,
            body: [
              [
                { text: '', style: 'tableHeaderBackground' },
                { text: 'Depósito', style: 'tableHeaderBackground' },
                { text: 'Rua', style: 'tableHeaderBackground' },
                { text: 'Prédio', style: 'tableHeaderBackground' },
                { text: 'Nível', style: 'tableHeaderBackground' },
                { text: 'Apto', style: 'tableHeaderBackground' },
                { text: 'Código', style: 'tableHeaderBackground' },
                { text: 'Descrição', style: 'tableHeaderBackground' },
                { text: 'Qtd', style: 'tableHeaderBackground' },
                { text: 'Valor Unit.', style: 'tableHeaderBackground' },
                { text: 'Valor Total', style: 'tableHeaderBackground' },
                { text: 'Obs', style: 'tableHeaderBackground' },
              ],
              ...dados,
            ],
            dontBreakRows: true,
          },
        },
        { text: ' ', margin: [0, 10] },
        ...Totais,
        {
          text: 'Obs:',
          fontSize: 9,
          bold: true,
          color: primaryColor,
          margin: [0, 20, 0, 5],
        },
        {
          text: obs || 'Sem observações',
          fontSize: 9,
          margin: [0, 0, 0, 10],
        },

        {
          text: additionalInfo,
          fontSize: 8,
          margin: [0, 0, 0, 10],
        },
      ],

      footer: function (currentPage, pageCount) {
        const dateTime = formatDateTime()
        if (currentPage === pageCount) {
          return [
            Rodape,
            {
              text: `Data e Hora da Impressão: ${dateTime}`,
              fontSize: 8,
              alignment: 'center',
              margin: [0, 10],
            },
          ]
        }
        return ''
      },

      styles: styles,

      defaultStyle: {
        fontSize: 10,
      },
    }

    // Crie o PDF e abra-o em uma nova guia
    pdfMake.createPdf(docDefinition).open()
  } catch (error) {
    console.error('Erro no pdfMake:', error)
  }
}

export default clientesPDF
